import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DeviceDetectorService } from 'ngx-device-detector';

export interface LedgerWarningModalData {
    description: string;
    helpCenterLink?: string;
    onCancel: () => void;
    onContinue: () => void;
    title: string;
    warning: string;
}

@Component({
    templateUrl: './ledger-warning-modal.component.html',
    styleUrls: ['./ledger-warning-modal.component.scss'],
    standalone: false
})
export class LedgerWarningModalComponent {
    constructor(@Inject(MAT_DIALOG_DATA) public data, public dialogRef: MatDialogRef<LedgerWarningModalComponent>, public deviceService: DeviceDetectorService) { }
}
